import {put, takeLatest, call} from 'redux-saga/effects';
import * as categoryService from "../../../services/categoryService";
import {
    DELETE_CATEGORY,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_ERROR
}
    from "../../actions/category";

function* deleteCategorySaga(action) {
    try {
        yield call(categoryService.DeleteCategory,action.payload)
        yield put({
            type: DELETE_CATEGORY_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: DELETE_CATEGORY_ERROR,error: error.data
        });
    }
}


export function* deleteCategorySagaWatcher() {
    yield takeLatest(DELETE_CATEGORY, deleteCategorySaga);
}